import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AppInfo = {
  __typename?: 'AppInfo';
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAppInfo?: Maybe<AppInfo>;
};

export type GetAppInfoDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppInfoDetailsQuery = { __typename?: 'Query', getAppInfo?: { __typename?: 'AppInfo', name: string, version: string } | null };


export const GetAppInfoDetailsDocument = gql`
    query getAppInfoDetails {
  getAppInfo {
    name
    version
  }
}
    `;

export function useGetAppInfoDetailsQuery(options?: Omit<Urql.UseQueryArgs<GetAppInfoDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAppInfoDetailsQuery, GetAppInfoDetailsQueryVariables>({ query: GetAppInfoDetailsDocument, ...options });
};